import type { OwnStayIngredient } from '@apps/main/modules/recipe/ingredients/ownStayIngredient';

import type { IngredientSerializer } from '../..';

import { serializeOwnStay } from './serialize';
import { deserializeOwnStay } from './deserialize';

export const OwnStaySerializer: IngredientSerializer<OwnStayIngredient> = {
  serialize: (hotel: OwnStayIngredient): string => serializeOwnStay(hotel),
  deserialize: (value: string): OwnStayIngredient => deserializeOwnStay(value),
};

export { OWN_STAY_INGREDIENT_SUFFIX } from './constants';
